import styled from '@emotion/styled';
import { Css, ITheme, UnstyledLi, UnstyledUl } from '@/ui';
import { Color } from '../../../../styles/Color';
import { Shadow } from '../../../../styles/Shadow';
import { RouterLink } from '../../link/RouterLink';
import { NavigationItemFocusState } from '../Navigation.styles';
import { dropdown } from '../../../../styles/animation/dropdown';
import { IMenuItemEntry } from '../../../../contentful/types/IMenuItem';
import { useCommonData } from '../../../../common-data/useCommonData';
import { getMenuItemMapping } from '../../../../utils/getMenuItemMapping';
import { IMenuItemNavBar } from '../../../../contentful/types/IMenuItemNavBar';

interface ISubNavigation {
	subMenuItems: IMenuItemEntry[];
	open: boolean;
}

export default function SubNavigation({ subMenuItems, open }: ISubNavigation) {
	const { pathToPageIdMap } = useCommonData();

	const menuItemNav = getMenuItemMapping(pathToPageIdMap, subMenuItems);

	if (!menuItemNav) {
		return null;
	}

	return (
		<StyledSubmenu open={open}>
			{open &&
				menuItemNav.map((item: IMenuItemNavBar) => (
					<StyledSubmenuItemWrap key={item.id}>
						<StyledSubmenuItem href={item.url}>{item.title}</StyledSubmenuItem>
					</StyledSubmenuItemWrap>
				))}
		</StyledSubmenu>
	);
}

const StyledSubmenu = styled(UnstyledUl)<{ open: boolean }>`
	background-color: ${Color.PrimaryWhite};
	width: ${Css.pxToRem(300)};
	height: fit-content;
	border-radius: 0 ${Css.pxToRem(16)} ${Css.pxToRem(16)};
	position: absolute;
	top: ${Css.pxToRem(48)};
	padding: ${Css.pxToRem(24)};
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(16)};
	font-weight: 400;
	box-shadow: ${Shadow.Small};
	${({ open }) => dropdown(open)}
`;

export const StyledSubmenuItemWrap = styled(UnstyledLi)`
	position: relative;
`;

export const StyledSubmenuItem = styled(RouterLink)<{}, ITheme>`
	text-decoration: none;
	color: ${Color.OnBackgroundText};

	&:hover {
		color: ${({ theme }) => theme.color.brand};
	}

	&:focus {
		outline: none;
	}

	&:focus-visible::after {
		${() => NavigationItemFocusState()}
		background-color: ${Color.PrimaryBlue87};
		left: ${Css.pxToRem(-10)};
		top: ${Css.pxToRem(-4)};
	}
`;
